import React, { useState } from 'react';

const IncomeReviewed = ({ onNext, answers, stepKey }) => {
  const [selectedAnswer, setSelectedAnswer] = useState(answers && answers[stepKey] ? answers[stepKey] : null);

  const handleClick = (value) => {
    setSelectedAnswer(value);
    onNext(value);
  };

  return (
    <>
      <div className="qs-card__head"><h2 className="qs-card__title">Was Your Income Reviewed?</h2></div>
      <div className="qs-card__body">
        <p className="qs-card__sub">Did the lender ask for details of your income and expenses before approving the car loan? </p>
        <div className="qs-actions">
          <button 
            type="button" 
            className={`qs-btn qs-btn--yes ${selectedAnswer == 475 ? 'btn-active' : ''}`}
            onClick={() => handleClick(475)}>
            Yes
          </button>
          <button 
            type="button" 
            className={`qs-btn qs-btn--no ${selectedAnswer == 476 ? 'btn-active' : ''}`}
            onClick={() => handleClick(476)}>
            No
          </button>
        </div>
      </div>
    </>
  );
};

export default IncomeReviewed;
